export default __webpack_public_path__ + "static/media/withdraw.ce2b3980.svg";